import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import TransactionMobileDialog from './TransactionMobileDialog';
import TransactionListItem from './TransactionListItem';
import Pagination from '../Pagination';
import JunoButton from '../common/JunoButton';
import EmptyStateScreen from '../common/EmptyStateScreen';

const TransactionMobileComponent = ({
    data,
    isDashboard,
    activeCurrencyPage,
    pageSize,
    currentPage,
    setCurrentPage,
    totalCount,
    }) => {
    const navigate = useNavigate();
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedTransaction, setSelectedTransaction] = useState({});
    const handleOpenDialog = transaction => {
        setSelectedTransaction(transaction);
        setOpenDialog(true);
    };

    const handleClose = () => {
        setOpenDialog(false);
    };
    return (
        <div className="block lg:hidden">
            {openDialog && (
                <TransactionMobileDialog
                    openDialog={openDialog}
                    handleClose={handleClose}
                    transaction={selectedTransaction}
                />
            )}
         <div className="flex flex-col bg-[#FFFFFF] dark:bg-[#26272B] md:flex-row lg:items-center justify-between items-center px-6 pt-6 pb-3 rounded-t-lg ">

            {isDashboard && activeCurrencyPage === 'crypto' && (
                <h2 className="font-semibold text-lg sm:text-sm leading-7 text-left w-full md:w-auto !text-section-title">
                    TRANSACTIONS
                </h2>
            )}
         </div>

            {data?.length === 0 ? (
                <EmptyStateScreen text="There are no transactions that match your criteria." />
            ) : (
                data?.map((transaction,index) => {
                    return (
                        <div
                            key={transaction?.transactionId}
                            onClick={() => handleOpenDialog(transaction)}>
                            <TransactionListItem transaction={transaction} />
                            {index < data.length - 1 && (
                            <div className="!text-secondary !bg-secondary  h-px w-full" />
                    )}
                        </div>
                    );
                })
            )}
         <div className="flex flex-col bg-[#FFFFFF] dark:bg-[#26272B] md:flex-row lg:items-center justify-between items-center rounded-b-lg">
            {isDashboard && (
                <div className="self-stretch px-6 pt-3 mb-6 inline-flex flex-col justify-start items-start gap-2.5 w-full">
                    <JunoButton type="secondary" onClick={() => navigate('/client/transactions')}>
                        See all
                    </JunoButton>
                </div>
            )}
            </div>

            {!isDashboard && data?.length > 0 && (
                <div className="flex justify-center py-4">
                    <Pagination
                        data={data}
                        pageSize={pageSize}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        totalCount={totalCount}
                    />
                </div>
            )}
        </div>
    );
};

TransactionMobileComponent.propTypes = {
    data: PropTypes.array.isRequired,
    isDashboard: PropTypes.bool,
    open: PropTypes.func,
    activeCurrencyPage: PropTypes.string,
};

export default TransactionMobileComponent;
